import GamesHubPage from '@/modules/gamification/pages/GamesHubPage.vue'
import GameDashboardPage from '@/modules/gamification/pages/GameDashboardPage.vue'
import GamesCataloguePage from '@/modules/gamification/pages/GamesCataloguePage.vue'
import GameCampaignsPage from '@/modules/gamification/pages/GameCampaignsPage.vue'
import GameCampaignsList from '@/modules/gamification/components/games-campaigns/GameCampaignsList.vue'
import GameCampaignPage from '@/modules/gamification/pages/GameCampaignPage.vue'
import GameCampaignsConfiguration from '@/modules/gamification/components/games-campaigns/GameCampaignsConfiguration.vue'
import GamesHubLoyaltyPage from '@/modules/gamification/pages/GamesHubLoyaltyPage.vue'

export default [
  {
    name: 'GamesHub',
    path: '/games-hub',
    component: GamesHubPage,
    meta: {
      projectFeatures: {
        items: ['enableGamification'],
        notFound: true
      },
      title: 'LeftNavigation_Games_Hub'
    }
  },
  {
    name: 'Loyalty',
    path: '/games-hub/loyalty',
    component: GamesHubLoyaltyPage,
    meta: {
      projectFeatures: {
        items: ['enableGamification'],
        notFound: true
      },
      title: 'LeftNavigation_Loyalty_Hub'
    }
  },
  {
    name: 'GamesHubDashboard',
    path: '/games-hub/dashboard',
    component: GameDashboardPage,
    meta: {
      projectFeatures: {
        items: ['enableGamification'],
        notFound: true
      }
    }
  },
  {
    name: 'GamesHubCatalogue',
    path: '/games-hub/catalogue',
    component: GamesCataloguePage,
    meta: {
      projectFeatures: {
        items: ['enableGamification'],
        notFound: true
      }
    }
  },
  {
    path: '/games-hub/:id',
    name: 'GameCampaignsPage',
    component: GameCampaignsPage,
    redirect: { name: 'GameCampaignsList' },
    meta: {
      projectFeatures: {
        items: ['enableGamification'],
        notFound: true
      }
    },
    children: [
      {
        name: 'GameCampaignsList',
        path: 'campaigns-list',
        component: GameCampaignsList
      },
      {
        name: 'GameCampaignsConfiguration',
        path: 'campaigns-configuration',
        component: GameCampaignsConfiguration
      }
    ]
  },
  {
    name: 'GameCreateCampaignPage',
    path: '/games-hub/:id/campaign/create',
    component: GameCampaignPage,
    meta: {
      projectFeatures: {
        items: ['enableGamification'],
        notFound: true
      }
    }
  },
  {
    name: 'GameEditCampaignPage',
    path: '/games-hub/:id/campaign/:campaignId/edit',
    component: GameCampaignPage,
    meta: {
      projectFeatures: {
        items: ['enableGamification'],
        notFound: true
      }
    }
  },
  {
    name: 'GameViewCampaignPage',
    path: '/games-hub/:id/campaign/:campaignId/view',
    component: GameCampaignPage,
    meta: {
      projectFeatures: {
        items: ['enableGamification'],
        notFound: true
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/gamification/router/index.js